var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#50c150;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-532 -5059)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 30,
    height: 30,
    rx: 5,
    transform: "translate(532 5059)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(535 5062)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.698 3.015)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M139.183,64.593a.9.9,0,0,0-1.279,0L127.053,75.414l-3.915-4.252a.9.9,0,1,0-1.331,1.225l4.553,4.944a.9.9,0,0,0,.646.292h.019a.905.905,0,0,0,.639-.264l11.518-11.487A.9.9,0,0,0,139.183,64.593Z",
    transform: "translate(-121.568 -64.327)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M23.1,11.1a.9.9,0,0,0-.9.9A10.191,10.191,0,1,1,12,1.809.9.9,0,1,0,12,0,12,12,0,1,0,24,12,.9.9,0,0,0,23.1,11.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.da8f849d7cb2fa37db780e8391e0d68d.svg";
export { ForwardRef as ReactComponent };